import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Body, Footer, Popup } from '@calendly/ui/components/popup'
import { BodyText } from '@calendly/ui/components/typography'
import { TextField } from '@calendly/ui/form/text-field'
import { useContext, useState } from 'react'

import { MeetingDetailDependenciesContext } from '../../../meeting_detail_context'

export const CancelInviteeModal = ({ invitee, onClose }) => {
  const dependencies = useContext(MeetingDetailDependenciesContext)
  if (!dependencies?.useCancelInviteeMutation) {
    throw new Error('CancelInviteeModal must be wrapped in a MeetingDetailDependenciesProvider with useCancelInviteeMutation')
  }

  const [cancelInvitee, { isLoading }] = dependencies.useCancelInviteeMutation()
  const [cancelReason, setCancelReason] = useState('')

  const handleSubmit = () => {
    cancelInvitee({ inviteeId: invitee.id, cancelReason })
    onClose()
  }

  return (
    <Popup
      title={I18n.t('publisher.scheduled_events.cancel_invitee.title', { invitee_name: invitee.name })}
      onClose={onClose}
    >
      <Body>
        <BodyText>
          {I18n.t('publisher.scheduled_events.cancel_invitee.description')}
        </BodyText>
        {invitee.hasCapturedCharge && (
          <BodyText>
            {I18n.t('publisher.scheduled_events.cancel_invitee.notice')}
          </BodyText>
        )}
        <TextField
          type="textarea"
          name="cancel_reason"
          placeholder={I18n.t('publisher.scheduled_events.cancel_reason_placeholder')}
          maxLength={1000}
          value={cancelReason}
          onChange={(e) => setCancelReason(e.target.value)}
        />
      </Body>
      <Footer>
        <Button
          decoration="secondary-outline"
          onClick={onClose}
        >
          {I18n.t('publisher.scheduled_events.cancel_invitee.cancel')}
        </Button>
        <Button
          loading={isLoading}
          decoration="danger"
          onClick={handleSubmit}
        >
          {I18n.t('publisher.scheduled_events.cancel_invitee.confirm')}
        </Button>
      </Footer>
    </Popup>
  )
}
